/**
 * API Configuration - Auto-detects environment
 * 
 * Uses window.location.origin to automatically determine the correct API URL.
 * This works for any deployment domain without hardcoding.
 */

const getApiBaseUrl = () => {
  // In browser, use current origin
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Local development - use env variable
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
    }
    
    // All other environments - use current origin
    return window.location.origin;
  }
  
  // Server-side fallback
  return process.env.REACT_APP_BACKEND_URL || '';
};

export const API_BASE_URL = getApiBaseUrl();
export const API = `${API_BASE_URL}/api`;

// Cache buster - append to GET requests to prevent CDN caching stale data
export const cacheBuster = () => `_cb=${Date.now()}`;

// Log API config on load (helps debug deployment issues)
console.log('API Config loaded:', { 
  API_BASE_URL, 
  API, 
  hostname: typeof window !== 'undefined' ? window.location.hostname : 'server' 
});
